export const DEMO_PROJECTS = [2195193, 2131808, 2132741, 2138137, 2131829, 2144029];

export const propMenuPrefetchEnabled = Math.random() >= 0.5;
